import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subtitleDashboard" }
const _hoisted_2 = {
  class: "subtitleDashboard",
  style: {"font-size":"24px !important"}
}
const _hoisted_3 = { class: "mt-8 mb-2 text-left" }
const _hoisted_4 = {
  key: 1,
  class: "text-left"
}

import { ref, computed } from 'vue';
import type { PropType } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import IEOCardComponent from '@/components/SmartLink/dashboard/IEOCardComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { ALARMTYPE } from '@/interfaces/SmartLink/KPI';

// 1. Recibir las alarmas recurrentes desde DashBoardView.vue

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageComponent',
  props: {
    recurrentAlarms: { 
        type: Array as PropType<ALARMTYPE[]>, 
        default: () => [] 
    }
},
  setup(__props) {

const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** INTERFACES **********
 *******************************/
const props = __props;

const heightTimeLine = ref(492);

// 2. Computed seguros para reaccionar a la prop sin errores
const allAlertItems = computed(() => props.recurrentAlarms || []);
const showAlertTimeLine = computed(() => allAlertItems.value.length > 0);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: _normalizeClass(_unref(mdAndDown) ? 'ma-0 mt-3' : 'ma-0'),
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pa-0",
        "align-self": "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('labels.ociTitle')) + " ", 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.oci')), 1)
          ]),
          _createVNode(IEOCardComponent, { width: 330 }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('labels.msn')), 1),
          (showAlertTimeLine.value)
            ? (_openBlock(), _createBlock(TimeLineAlerts, {
                key: 0,
                class: "text-left",
                "array-items": allAlertItems.value,
                width: _unref(smAndDown) ? 400 : 315,
                height: heightTimeLine.value,
                isRecurrent: true
              }, null, 8, ["array-items", "width", "height"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('noAlertsAlarmRecurren')), 1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})